<template>
  <TrainerLayout>
    <div
      class="flex h-screen chat-screen-height mt-2 md:py-0 w-full mx-auto"
    >
      <!-- Left pane block for message list starts -->
      <div
        class="flex-1 flex-row w-96 flex-shrink-0 bg-gray-100 sm:max-w-xs"
        v-show="showChats || screenSize > 640"
      >
        <div
          class="flex flex-col w-full h-full shadow-lg bg-white rounded-t-lg ring-1 ring-gray-300 overflow-auto"
        >
          <!--only for user-->
          <template v-if="module === 'USER'">
            <div class="relative text-gray-700">
              <!-- class="form-input block w-full border-gray-300 border-b" -->
              <input
                class="w-full h-10 pl-8 pr-3 text-base placeholder-gray-600 ring-1 ring-gray-300 rounded-lg focus:shadow-outline"
                type="search"
                placeholder="Search"
                v-model="searchText"
                v-on:input="handleMessagesSearch"
              />
            </div>
            <div
              v-if="
                messages &&
                messages.message_requests &&
                messages.message_requests.length > 0
              "
            >
              <div
                v-for="message in messages.message_requests"
                :key="message.id"
              >
                <!-- @click="
                    handleRequestPendingMessages(
                      message.from_user_id,
                      message.to_user_id
                    )
                  " -->
                <div
                  class="flex border-b border-gray-300 py-2 px-2 items-center"
                  :class="message.status == 0 ? 'text-gray-light' : ''"
                >
                  <img
                    class="h-12 rounded-full mr-2 object-cover"
                    :src="baseUrlSrc(message && message.thumbnail_url)"
                    alt=""
                    @error="defaultCircleImage"
                  />
                  <div class="flex items-center justify-between w-full">
                    <div>
                      <p class="font-medium capitalize">
                        {{ message.f_name }} {{ message.l_name }}
                      </p>
                      <small class="text-gray-light text-sm"> Pending </small>
                    </div>
                    <div>
                      <span class="text-sm text-gray-light">{{
                        handleHour12(message.created_at)
                      }}</span>
                    </div>
                  </div>
                </div>
              </div>
            </div>

            <div v-for="message in messages.chats" :key="message.id">
              <div
                class="flex border-b border-gray-300 py-2 px-2 items-center"
                :class="{
                  'bg-gray-300':
                    chatFromTo &&
                    chatFromTo.profile &&
                    chatFromTo.profile[0] &&
                    message &&
                    chatFromTo &&
                    chatFromTo.profile &&
                    chatFromTo.profile[0].to_user_id == message.to_user_id,
                }"
                @click="showChat(message.chat_id)"
              >
                <img
                  class="h-12 rounded-full mr-2 object-cover"
                  :src="baseUrlSrc(message.img || message.thumbnail_url)"
                  alt=""
                  @error="defaultCircleImage"
                />
                <div class="flex items-center justify-between w-full">
                  <div>
                    <p class="font-medium capitalize">
                      {{ message.to_name || message.name }}
                    </p>
                    <small class="text-gray-light text-sm">
                      {{ message.message.substing }}
                    </small>
                  </div>
                  <div v-if="message.created_at">
                    <span class="text-sm text-gray-light">{{
                      handleHour12(message.created_at)
                    }}</span>
                  </div>
                </div>
              </div>
            </div>
          </template>

          <!--trainer left side-->
          <template v-else>
            <tabs ref="tabs" :isActive="!isRequestOpen" :reqCount="getRequestCount">
              <tab title="Chat">
                <div class="relative text-gray-700">
                  <input
                    class="w-full h-10 pl-8 pr-3 text-base placeholder-gray-600 ring-1 ring-gray-300 rounded-lg focus:shadow-outline"
                    type="search"
                    placeholder="Search"
                    v-model="searchText"
                    v-on:input="handleMessagesSearch"
                  />
                  <div
                    class="absolute inset-y-0 left-0 flex items-center px-2 pointer-events-none"
                  >
                    <Search />
                  </div>
                </div>
                <p
                  class="text-gray-light text-center py-2"
                  v-if="messages.length == 0"
                >
                  No Users
                </p>
                <!-- Avatar groups with actions -->
                <div class="flow-root mt-6">
                  <ul role="list" class="-my-5 divide-y divide-gray-200 border">
                    <li
                      v-for="message in messages"
                      :key="message.id"
                      class="p-2 hover:bg-blue-light cursor-pointer"
                      :class="chatFromTo && chatFromTo.profile && chatFromTo.profile[0] && chatFromTo.profile[0].chat_id && chatFromTo.profile[0].chat_id === message.chat_id ? 'bg-blue-light' : ''"
                      @click="showChatWidow()"
                    >
                    <div
                        class="flex items-center space-x-4"
                        @click="
                          showChat(message.chat_id)
                        "
                      >
                        <div class="flex-shrink-0 relative">
                          <img
                            class="h-12 w-12 rounded-full"
                            :src="baseUrlSrc(message && message.img)"
                            alt=""
                            @error="defaultCircleImage"
                          />
                          <span
                            class="absolute bottom-0 right-0 inline-block w-3 h-3 bg-green-light ring-1 ring-white rounded-full"
                          >
                          </span>
                        </div>
                        <div class="flex-1 min-w-0">
                          <p
                            class="text-sm font-medium text-gray-900 truncate capitalize"
                          >
                            {{ message.from_name }}
                          </p>
                          <p class="text-sm text-gray-500 truncate">
                            {{ message.message.substring(0, 20) }}
                          </p>
                        </div>
                        <div>
                          <p
                            class="inline-flex items-center px-2.5 py-0.5 text-sm leading-5 font-medium text-gray-700"
                          >
                            {{ formatDateTime(message.created_at, "h:mm A") }}
                          </p>
                        </div>
                      </div>
                    </li>
                  </ul>
                </div>
              </tab>
              <tab title="Requests">
                <!-- Avatar groups with actions -->
                <div class="flow-root mt-6" v-if="messageRequests.length > 0">
                  <ul role="list" class="-my-5 divide-y divide-gray-200 border">
                    <li
                      class="p-2 hover:bg-blue-light cursor-pointer"
                      v-for="requests in messageRequests"
                      :key="requests.id"
                      :class="chatFromTo && chatFromTo.profile && chatFromTo.profile[0] && chatFromTo.profile[0].chat_id && chatFromTo.profile[0].chat_id === requests.id ? 'bg-blue-light' : ''"
                    >
                      <div
                        class="flex items-center space-x-4"
                        @click="showreq(requests)"
                      >
                        <div class="flex-shrink-0 relative">
                          <!-- class="h-10 w-10 rounded-full object-cover float-left clear-both" -->
                          <img
                            class="h-12 w-12 rounded-full"
                            :src="baseUrlSrc(requests && requests.img)"
                            alt=""
                            @error="defaultCircleImage"
                          />
                          <span
                            class="absolute bottom-0 right-0 inline-block w-3 h-3 bg-green-light ring-1 ring-white rounded-full"
                          >
                          </span>
                        </div>
                        <div class="flex-1 min-w-0">
                          <p
                            class="text-sm font-medium text-gray-900 truncate capitalize"
                          >
                            {{ requests.from_name }}
                          </p>
                          <p class="text-sm text-gray-500 truncate">
                            Private Class booking
                          </p>
                        </div>
                        <div>
                          <span
                            class="inline-flex items-center px-2.5 py-0.5 text-sm leading-5 font-medium text-gray-700 bg-white"
                          >
                            <!-- created_at -->
                          </span>
                        </div>
                      </div>
                    </li>
                  </ul>
                </div>
                <div v-else>
                  <p class="text-gray-light text-center py-2">
                    No pending message requests
                  </p>
                </div>
              </tab>
            </tabs>
          </template>
        </div>
      </div>
      <!-- Left pane block for message list ends -->

      <div
        class="flex flex-col items-center justify-center w-8/12"
        v-if="isChatEmpty"
      >
        <img
          :src="require(`@/assets/svg/chat-empty.svg`)"
          class="ml-24"
          alt="..."
        />
        <div class="mt-5">
          <p class="text-xl text-gray-700 text-center">
            Looks like there is nothing here yet,
          </p>
          <p class="text-xl text-gray-700 text-center">
            You can connect with participants by approving their requests
          </p>
        </div>
      </div>
      <div
        class="flex-1 justify-between flex flex-col shadow-lg rounded-r-lg pb-2 ring-1 ring-gray-300 bg-gray-lightest"
        v-show="showMesages || screenSize > 640"
        v-if="!isChatEmpty"
      >
        <div
          class="flex sm:items-center justify-between py-1 px-2 border-b-2 border-gray-200"
          v-if="isChatOpen"
        >
          <i
            class="absolute mt-3 cursor-pointer block sm:hidden"
            @click="showChatWidow()"
          >
            <ChevronLeft classStr="text-gray-light w-6 h-6" />
          </i>
          <!-- Narrow with avatar group -->
          <ul role="list" class="divide-y divide-gray-200">
            <li class="py-1 flex">
              <div class="relative inline-block">
                <img
                  class="h-10 w-10 rounded-full"
                  :src="
                    chatFromTo &&
                    chatFromTo.profile &&
                    chatFromTo.profile[0] &&
                    chatFromTo.profile[0].to_thumbnail_url
                      ? `${baseUrlSrc(
                          chatFromTo &&
                            chatFromTo.profile &&
                            chatFromTo.profile[0] &&
                            chatFromTo.profile[0].to_thumbnail_url
                        )}`
                      : ''
                  "
                  alt=""
                  @error="defaultCircleImage"
                  v-if="module === 'USER'"
                />
                <img
                  class="h-10 w-10 rounded-full"
                  :src="
                    chatFromTo &&
                    chatFromTo.profile &&
                    chatFromTo.profile[0] &&
                    chatFromTo.profile[0].from_thumbnail_url
                      ? `${baseUrlSrc(
                          chatFromTo &&
                            chatFromTo.profile &&
                            chatFromTo.profile[0] &&
                            chatFromTo.profile[0].from_thumbnail_url
                        )}`
                      : ''
                  "
                  alt=""
                  @error="defaultCircleImage"
                  v-else
                />
                <span
                  class="absolute bottom-0 right-0 inline-block w-3 h-3 bg-green-light ring-1 ring-white rounded-full"
                ></span>
              </div>
              <div class="ml-3">
                <p class="text-sm font-medium text-gray-900 capitalize">
                  {{ userMessages.to_name }}
                  {{
                        chatFromTo &&
                        chatFromTo.profile &&
                        chatFromTo.profile[0] &&
                        chatFromTo.profile[0].name
                  }}
                </p>
                <p class="text-sm text-gray-500">Private Class booking</p>
              </div>
            </li>
          </ul>
          <div class="flex items-center space-x-2 relative" v-if="chatFromTo && chatFromTo.profile && chatFromTo.profile[0] && chatFromTo.profile[0].requests_status !== 1">
            <button
              type="button"
              class="focus:outline-none"
              @click="isChatMenuOpen = !isChatMenuOpen"
              v-click-outside="handleIsChatMenuOpen"
            >
              <DotsVertical />
            </button>
            <div
              class="origin-top-right absolute w-32 right-0 mt-16 rounded-md shadow-lg bg-white ring-1 ring-gray-300 ring-opacity-5 z-10"
              v-if="isChatMenuOpen"
            >
              <div
                class="py-0"
                role="menu"
                aria-orientation="vertical"
                aria-labelledby="options-menu"
              >
                <button
                  v-if="chatFromTo.profile[0].requests_status == 2"
                  type="button"
                  class="block px-4 py-2 text-sm text-gray-700 hover:bg-gray-100 hover:text-gray-900"
                  role="menuitem"
                  @click="
                    handleChatEnd(
                      chatFromTo &&
                        chatFromTo.profile &&
                        chatFromTo.profile[0] &&
                        chatFromTo.profile[0].chat_id
                    )
                  "
                >
                  End Chat
                </button>
                <button
                 v-if="chatFromTo.profile[0].requests_status == 4"
                  type="button"
                  class="block px-4 py-2 text-sm text-gray-700 hover:bg-gray-100 hover:text-gray-900"
                  role="menuitem"
                  @click="
                    onclickReopen(
                      chatFromTo &&
                        chatFromTo.profile &&
                        chatFromTo.profile[0] &&
                        chatFromTo.profile[0].chat_id
                    )
                  "
                >
                  Reopen
                </button>
                <!-- <button
                  type="button"
                  class="block px-4 py-2 text-sm text-gray-700 hover:bg-gray-100 hover:text-gray-900"
                  role="menuitem"
                  @click="handleUserReportingModal(true)"
                >
                  Report
                </button> -->
              </div>
            </div>
          </div>
        </div>
        <UserReportingModal
          v-if="isUserReportingModalOpen"
          :isUserReportingModalOpen="isUserReportingModalOpen"
          :handleUserReportingModal="handleUserReportingModal"
          :category_id="4"
        />
        <div
          id="messages"
          class="flex relative flex-col space-y-4 p-3 overflow-y-auto scrollbar-thumb-blue scrollbar-thumb-rounded scrollbar-track-blue-lighter scrollbar-w-2 scrolling-touch chat-typo-container"
        >
        <div
            v-if="lastPage > currentPage && lastPage > 1 && !isRequestOpen"
            class="m-auto"
            @click="
              handleEarlierMessages(
                chatFromTo &&
                  chatFromTo.data &&
                  chatFromTo.data[0] &&
                  chatFromTo.data[0].chat_id
              )
            "
          >
            <button
              class="px-2 bg-white max-w-xs text-xs rounded-full ring-1 ring-gray-400 text-center flex"
            >
              See Earlier Messages <ChevronUp class="w-4 mt-arrow ml-0.5" />
            </button>
          </div>
          <div class="chat-message" v-for="c in chatFromTo.data" :key="c.id">
            <div
              class="flex"
              :class="c.from_user_id == user.id ? 'justify-end' : ''"
            >
              <div
                class="flex flex-col space-y-2 text-xs max-w-xs mx-2"
                :class="
                  c.from_user_id == user.id
                    ? 'items-end order-1'
                    : 'order-2 items-start'
                "
              >
                <div
                  class="flex flex-col"
                  :class="c.from_user_id == user.id ? 'items-end' : ''"
                >
                  <p
                    class="px-4 py-2 rounded-lg inline-block"
                    :class="
                      c.from_user_id == user.id
                        ? 'rounded-br-none bg-blue-lightest text-black'
                        : 'rounded-bl-none bg-gray-300 text-gray-dark'
                    "
                  >
                    {{ c.message }}
                  </p>
                  <small class="text-gray-light"
                    >{{ handleMonthDateTime(c.created_at, "time") }}
                  </small>
                </div>
              </div>
              <img
                :src="baseUrlSrc(c.from_thumbnail_url)"
                alt=""
                @error="defaultCircleImage"
                class="w-6 h-6 rounded-full"
                :class="c.from_user_id == user.id ? 'order-2' : 'order-1'"
              />
            </div>
          </div>
          <!-- <div
            v-if="1 < currentPage && !isRequestOpen"
            class="m-auto"
            @click="
              handleLoadLessMessages(
                chatFromTo &&
                  chatFromTo.data &&
                  chatFromTo.data[0] &&
                  chatFromTo.data[0].chat_id
              )
            "
          >
            <button
              class="px-2 bg-white max-w-xs text-xs absolute bottom-0 left-4 rounded-full ring-1 ring-gray-400 text-center flex"
            >
              See Newer Messages <ChevronDown class="w-4 mt-arrow ml-0.5" />
            </button>
          </div> -->
          <div class="request-permission-section px-4" v-if="isRequestOpen">
            <div class="w-full float-right">
              <button
                class="h-10 px-4 m-2 text-sm text-green-light transition-colors duration-150 ring-1 ring-green-light rounded-lg focus:shadow-outline hover:bg-green-light hover:text-white"
                @click="rejectChat(chatFromTo.data[0].id)"
                id="0"
                ref="rejectBtn"
              >
                Reject
              </button>
              <button
                class="h-10 px-4 m-2 text-sm text-indigo-100 transition-colors duration-150 bg-green-light rounded-lg focus:shadow-outline hover:bg-green-light"
                @click="acceptChat(chatFromTo.data[0].id)"
                ref="acceptBtn"
              >
                Accept
              </button>
            </div>
          </div>
        </div>
        <div class="px-2 pt-4 mb-2 sm:mb-0">
          <div
            class="relative flex"
            v-if="
              chatFromTo &&
              chatFromTo.profile &&
              chatFromTo.profile[0] &&
              chatFromTo.profile[0].requests_status != 4 && chatFromTo.profile[0].requests_status != 1
            "
          >
            <!-- Input with SVG icon left. -->
            <div class="relative text-gray-700 w-full">
              <!-- class="w-full focus:outline-none text-sm text-gray-light pl-4 bg-gray-200 rounded-md py-2" -->
              <input
                class="w-full h-10 pl-8 pr-3 text-base placeholder-gray-600 ring-1 ring-gray-300 rounded-lg focus:outline-none"
                type="text"
                placeholder="Send your message"
                v-model="$v.message.$model"
                @keyup.enter="
                  module === 'TRAINER'
                    ? sendMessage(chatFromTo.profile[0].chat_id)
                    : module === 'USER'
                    ? sendMessage(chatFromTo.profile[0].chat_id)
                    : null
                "
              />
              <div
                class="absolute inset-y-0 left-0 flex items-center px-2 pointer-events-none"
              >
                <svg
                  xmlns="http://www.w3.org/2000/svg"
                  class="h-5 w-5"
                  fill="none"
                  viewBox="0 0 24 24"
                  stroke="currentColor"
                >
                  <path
                    stroke-linecap="round"
                    stroke-linejoin="round"
                    stroke-width="2"
                    d="M14.828 14.828a4 4 0 01-5.656 0M9 10h.01M15 10h.01M21 12a9 9 0 11-18 0 9 9 0 0118 0z"
                  />
                </svg>
              </div>
              <button
                type="button"
                class="absolute inset-y-0 right-0 flex items-center px-4 font-bold text-white bg-green-light rounded-r-lg hover:bg-green-light focus:bg-indigo-100"
                :disabled="
                  chatFromTo &&
                  chatFromTo.data &&
                  chatFromTo.data[0] &&
                  chatFromTo.data[0].requests_status &&
                  chatFromTo.data[0].requests_status == 2
                    ? false
                    : 'disabled'
                "
                @click="
                  chatFromTo &&
                  chatFromTo.data &&
                  chatFromTo.data[0] &&
                  chatFromTo.data[0].requests_status &&
                  chatFromTo.data[0].requests_status == 2
                    ? sendMessage(chatFromTo.data[0].chat_id)
                    : chatFromTo &&
                      chatFromTo.data &&
                      chatFromTo.data[0] &&
                      chatFromTo.data[0].requests_status &&
                      chatFromTo.data[0].requests_status == 2 &&
                      module === 'USER'
                    ? sendMessage(chatFromTo.data[0].chat_id)
                    : null
                "
              >
                <svg
                  xmlns="http://www.w3.org/2000/svg"
                  viewBox="0 0 20 20"
                  fill="currentColor"
                  class="h-4 w-4 transform rotate-90"
                >
                  <path
                    d="M10.894 2.553a1 1 0 00-1.788 0l-7 14a1 1 0 001.169 1.409l5-1.429A1 1 0 009 15.571V11a1 1 0 112 0v4.571a1 1 0 00.725.962l5 1.428a1 1 0 001.17-1.408l-7-14z"
                  ></path>
                </svg>
              </button>
            </div>
          </div>
          <div
            v-if="
              chatFromTo &&
              chatFromTo.profile &&
              chatFromTo.profile[0] &&
              chatFromTo.profile[0].requests_status == 4
            "
          >
            <ConversationClosed />
          </div>
        </div>
      </div>
    </div>
  </TrainerLayout>
</template>

<script>
import TrainerLayout from "@/components/layouts/TrainerLayout";
import {
  DotsVertical,
  Search,
  ChevronLeft,
  ChevronUp,
  ChevronDown,
} from "@/components/icons";
import Tab from "@/components/message/Tab";
import Tabs from "@/components/message/Tabs";
import ConversationClosed from "@/components/message/ConversationClosed";
import UserReportingModal from "@/components/UserReportingModal.vue";
import { mapGetters, mapActions } from "vuex";
import { required } from "vuelidate/lib/validators";
import ClickOutside from "vue-click-outside";
import debounce from "debounce";

export default {
  components: {
    TrainerLayout,
    DotsVertical,
    Tab,
    Tabs,
    Search,
    ConversationClosed,
    UserReportingModal,
    ChevronLeft,
    ChevronUp,
    ChevronDown,
  },
  data() {
    return {
      messageRequests: [],
      messages: [],
      message: "",
      isRequestOpen: false,
      isChatOpen: false,
      user: JSON.parse(localStorage.getItem("user")),
      details: JSON.parse(localStorage.getItem("details")),
      isChatMenuOpen: false,
      module: "TRAINER",
      searchText: "",
      isUserReportingModalOpen: false,
      showChats: true,
      showMesages: false,
      screenSize: window.innerWidth,
      isChatEmpty: false,
      currentPage: 1,
      lastPage: 1,
      isScrollApplicable: true
    };
  },
  validations: {
    message: {
      required,
      correctMessage(message) {
        //regex for not accepting url in chat
        var regex = new RegExp(
          /^(?:(?:https?|ftp):\/\/)(?:\S+(?::\S*)?@)?(?:(?!(?:10|127)(?:\.\d{1,3}){3})(?!(?:169\.254|192\.168)(?:\.\d{1,3}){2})(?!172\.(?:1[6-9]|2\d|3[0-1])(?:\.\d{1,3}){2})(?:[1-9]\d?|1\d\d|2[01]\d|22[0-3])(?:\.(?:1?\d{1,2}|2[0-4]\d|25[0-5])){2}(?:\.(?:[1-9]\d?|1\d\d|2[0-4]\d|25[0-4]))|(?:(?:[a-z\u00a1-\uffff0-9]-*)*[a-z\u00a1-\uffff0-9]+)(?:\.(?:[a-z\u00a1-\uffff0-9]-*)*[a-z\u00a1-\uffff0-9]+)*(?:\.(?:[a-z\u00a1-\uffff]{2,}))\.?)(?::\d{2,5})?(?:[/?#]\S*)?$/i
        );
        if (!regex.test(message)) {
          return true;
        }
      },
    },
  },
  computed: {
    ...mapGetters([
      "trainerMessageRequests",
      "trainerMessages",
      "chatFromTo",
      "userMessages",
    ]),
    getRequestCount () {
      return this.messageRequests && this.messageRequests.length
    }
  },
  methods: {
    ...mapActions([
      "getTrainerMessageRequest",
      "getTrainerMessages",
      "getChat",
      "chatOut",
      "chatEnd",
      "postChatReopen",
      "getChatFromTo",
      "trainerRequestStatus",
      "getRequestPendingMessages",
      "getUserMessages",
    ]),

    handleUserReportingModal(val) {
      this.isUserReportingModalOpen = val;
    },

    async showChat(chatId) {
      const data = {
        chat_id: chatId
      };
      this.isScrollApplicable = true
      this.currentPage = 1;
      const query = {
        page: this.currentPage,
      };
      await this.getChatFromTo({ query, data });
      this.currentPage = this.chatFromTo.current_page;
      this.lastPage = this.chatFromTo.last_page;
      if (this.isChatOpen == false) {
        this.isChatOpen = !this.isChatOpen;
      }
      if (this.isRequestOpen == true) {
        this.isRequestOpen = !this.isRequestOpen;
      }
    },

    showreq(requests) {
      if (this.isChatOpen == false) {
        this.isChatOpen = !this.isChatOpen;
      }
      if (this.isRequestOpen == false) {
        this.isRequestOpen = !this.isRequestOpen;
      }
      this.isScrollApplicable = true
      const data = {
        from: requests && requests.from_user_id,
        to: requests && requests.to_user_id,
      };
      this.getRequestPendingMessages(data);
      this.isChatEmpty = false;
    },

    async sendMessage(id) {
      this.$v.message.$touch();
      this.isScrollApplicable = true
      if (!this.$v.message.$invalid) {
        let date = new Date();
        date = this.convertLocalDateToUTCDate(date);
        const data = {
          message: this.message,
          chat_id: id,
          date,
        };
        // const message_data = {
        //   message: this.message,
        //   created_at: date,
        //   chat_id: id,
        //   thumbnail_url: this.details.thumbnail_url,
        // };
        // this.chatFromTo.data.push(message_data);
        this.message = "";
        this.chatOut(data).then(() => {
          this.showChat(id);
        })

        // if (this.$route.name === "UserMessage") {
        //   this.module = "USER";
        //   this.setUserDetails();
        // } else {
        //   this.module = "TRAINER";
        //   this.setTrainerDetails();
        // }
        this.message = "";
      }
    },

    async acceptChat(acceptId) {

      const data = {
        status: 2, // accepted
        message: acceptId,
      };
      this.$store.commit('setIsLoading', true)
      await this.trainerRequestStatus(data).then(async () => {
        await this.getTrainerMessageRequest();
        await this.getTrainerMessages({});
        this.$store.commit('setIsLoading', false)
        this.messageRequests = this.trainerMessageRequests;
        this.messages = this.trainerMessages;
        // this.isRequestOpen = false;
        let tabsAccess = this.$refs && this.$refs.tabs
        if (tabsAccess) {
          this.$refs.tabs.selectTab(0)
          this.showChatWidow()
          this.showChat(acceptId)
        }
      })
    },

    async rejectChat(rejectId) {
      const data = {
        status: 3, // rejected
        message: rejectId,
      };
      this.$store.commit('setIsLoading', true)
      await this.trainerRequestStatus(data).then(async () => {
        await this.getTrainerMessageRequest();
        await this.getTrainerMessages({});
        this.$store.commit('setIsLoading', false);
        this.messageRequests = this.trainerMessageRequests;
        this.messages = this.trainerMessages;
        this.$store.commit('setChatFromTo', [])
        this.isRequestOpen = false;
        this.isChatOpen = false;
        // this.showreq()
      })
    },

    handleIsChatMenuOpen() {
      this.isChatMenuOpen = false;
    },

    handleChatEnd(chatId) {
      const data = {
        status: 0,
        chat_id: chatId,
      };
      this.chatEnd(data).then(() => {
        // if (this.$route.name === "UserMessage") {
        //   this.module = "USER";
        //   this.setUserDetails();
        // } else {
        //   this.module = "TRAINER";
        //   this.setTrainerDetails();
        // }
        this.showChat(chatId);
        // this.$store.dispatch('')
      })
    },

    onclickReopen(chatId) {
      const data = {
        chat_id: chatId,
      };
      this.postChatReopen(data).then(() => {
        this.showChat(chatId);
      })
    },

    // to set the user details initially
    async setUserDetails() {
      await this.getUserMessages({});
      this.messages = this.userMessages;
      const data = {
        chat_id: this.messages && this.messages.chats && this.messages.chats[0] && this.messages.chats[0].chat_id
      };
      if (data && data.from) {
        const query = {
          page: this.currentPage,
        };
        await this.getChatFromTo({ query, data });
        this.currentPage = await this.chatFromTo.current_page;
        this.lastPage = await this.chatFromTo.last_page;
        this.isChatOpen = true;
      }
      await this.getUserMessages({});
      this.messages = this.userMessages;
    },

    // to set the trainer details initially
    async setTrainerDetails(shuffleUserList = true) {
      await this.getTrainerMessageRequest();
      this.messageRequests = this.trainerMessageRequests;
      await this.getTrainerMessages({});
      this.messages = this.trainerMessages;
      const data = {
        chat_id: this.messages && this.messages[0] && this.messages[0].chat_id
      };
      if (data && data.from) {
        const query = {
          page: this.currentPage,
        };
        if (shuffleUserList) {
          await this.getChatFromTo({ query, data });
        }
        this.currentPage = await this.chatFromTo.current_page;
        this.lastPage = await this.chatFromTo.last_page;
        this.isChatOpen = true;
      }
      await this.getTrainerMessages({});
      this.messages = this.trainerMessages;
    },

    async handleEarlierMessages(chatId) {
      const data = {
        chat_id: chatId
      };
      this.currentPage++;
      const query = {
        page: this.currentPage,
      };
      this.isScrollApplicable = false
      this.$store.dispatch('getEarlierChatMsgs', { query, data })
      // await this.getChatFromTo({ query, data });
    },

    async handleLoadLessMessages(chatId) {
      const data = {
        chat_id: chatId
      };
      this.currentPage--;
      const query = {
        page: this.currentPage,
      };
      await this.getChatFromTo({ query, data });
    },

    handleScrollBottom() {
      var messages = document.getElementById("messages");
      if (messages) {
        messages.scrollTop = messages.scrollHeight;
      }
    },

    handleOnLoad() {
      var messages = document.getElementById("messages");
      messages && messages.classList.add("flex-col-reverse");
    },

    showChatWidow() {
      this.showChats = !this.showChats;
      this.showMesages = !this.showMesages;
      this.isChatEmpty = false;
    },

    handleMessagesSearch: debounce(async function () {
      const payload = {
        q: this.searchText,
      };
      if (this.module === "USER") {
        await this.getUserMessages({ payload });
        this.messages = this.userMessages;
      } else {
        await this.getTrainerMessages({ payload });
        this.messages = this.trainerMessages;
      }
    }, 1000),
  },
  mounted() {
    window.addEventListener("resize", () => {
      this.screenSize = window.innerWidth;
    });
  },
  updated() {
    this.isScrollApplicable ? this.handleScrollBottom() : ''
  },
  async created() {
    if (this.$route.name === "UserMessage") {
      this.module = "USER";
      this.setUserDetails();
    } else {
      this.module = "TRAINER";
      if (this.$route.params && this.$route.params.user_id) {
        this.setTrainerDetails(false);
      } else {
        this.setTrainerDetails();
      }
    }

    this.handleOnLoad();
    // await this.getTrainerMessages({});
    if (this.trainerMessages.length == 0) {
      this.isChatEmpty = true;
    }
    if (this.$route.params && this.$route.params.chat_id) {
      const chat_id = this.$route.params.chat_id;
      this.showChat(chat_id);
    }
  },
  directives: {
    ClickOutside,
  },
};
</script>
<style scoped>
.chat-screen-height {
  height: 87vh !important;
}
.chat-typo-container {
  position: relative;
  height: 100%;
}
.request-permission-section {
  position: absolute;
  bottom: 10px;
  right: 0;
}
.left-4 {
  left: 40%;
}
@media only screen and (max-width: 420px) {
  .left-4 {
    left: 30%;
  }
}
</style>